export default __webpack_public_path__ + "static/burger-menu-cb1106b48fc19bf48fa29a77184b1842.png";